export const ProjectData = [
    {
        title: 'Portfolio Site',
        photos: ['img/portfolio-site1.png'],
        date: 'October 1, 2020',
        technologies: ['React, ', 'Hooks, ', 'Serverless Functions, ', 'FaunaDB'],
        repo: 'https://github.com/RyanLuttrell/personal-site',
        briefDescription: 'This has by far been the most intimidating project I\'ve built. Not because it was a particularly challenging site to build, but rather because this is the first time that I\'m putting myself out there as a Software Engineer.',
        fullDescription: 'Ryan Luttrell\'s portfolio website',
        alt: 'A modern portfolio site build using React',
        readMore: ''
    },
    {
        title: 'React Web App With Rest API',
        photos: ['img/final-project.jpg'],
        date: 'September 15, 2020',
        technologies: ['React, ', 'RestAPIs, ', 'SQL, ', 'sqlite, ', 'Express, ', 'Nodejs'],
        repo: 'https://github.com/RyanLuttrell/react-with-rest-api',
        briefDescription: 'This was the final project on my way to completing the Full-Stack JavavScript Tech Degree from TreeHouse. Full authentication, a RestAPI, React Front-end and even a mini CMS for the course content',
        fullDescription: '',
        alt: 'A learning platform that allows users to create, edit and delete lessons ',
        readMore: ''
    },
    {
        title: 'Simple Express Site',
        photos: ['img/api1.jpg'],
        date: 'August 12, 2020',
        technologies: ['HTTP, ', 'APIs, ', 'Express, ', 'Nodejs',],
        repo: 'https://github.com/RyanLuttrell/Employee-Directory-Project',
        briefDescription: 'A very simple Nodejs site using Express',
        fullDescription: '',
        alt: 'A simple NodeJS site using express to show employees',
        readMore: ''
    },
]